// extracted by mini-css-extract-plugin
module.exports = {"hero":"_1UATM","hero_content_wrapper":"_1btsi","hero_content":"_1sAdg","list_item":"_2aDI1"};